// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Pagination--pagination--Zstt5","pages":"Pagination--pages--sn_pD","arrow":"Pagination--arrow--i0Yec","active":"Pagination--active--3SyUE"};